import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from '../button/button';

interface SymptomAssessmentIntroProps {
  setStarted(): void;
  isGuardianUser: boolean;
  playerFirstName: string;
  guardianEmails: string[];
}

export function SymptomAssessmentIntro({
  setStarted,
  isGuardianUser,
  playerFirstName,
  guardianEmails,
}: SymptomAssessmentIntroProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const instructions = [
    {
      key: 'INSTRUCTION1',
      value: t('symptom.NEW_SYMPTOM_CHECK_INSTRUCTION1', {
        playerFirstName,
      }),
    },
    {
      key: 'INSTRUCTION3',
      value: t('symptom.NEW_SYMPTOM_CHECK_INSTRUCTION3'),
    },
  ];

  if (!isGuardianUser && guardianEmails.length) {
    instructions.splice(1, 0, {
      key: 'INSTRUCTION2',
      value: t('symptom.NEW_SYMPTOM_CHECK_INSTRUCTION2', {
        guardianEmails: guardianEmails.join(', '),
      }),
    });
  }

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      justifyContent="space-between"
      pt={6}
    >
      <Grid item textAlign="center">
        <Typography variant="h5" fontWeight="bold">
          {t('symptom.NEW_SYMPTOM_CHECK_TITLE')}
        </Typography>
        <Typography variant="subtitle2">
          {t('symptom.NEW_SYMPTOM_CHECK_SUBTITLE')}
        </Typography>
      </Grid>

      <Grid item sx={{ my: 5 }} textAlign="center">
        <InfoIcon color="primary" fontSize="large" />
      </Grid>

      <Grid item textAlign="center">
        <Typography variant="body1">
          {t('symptom.NEW_SYMPTOM_CHECK_INSTRUCTIONS_TITLE')}
        </Typography>
      </Grid>

      <Grid item sx={{ alignSelf: 'center' }}>
        {instructions.map((instruction) => (
          <Grid
            container
            direction="row"
            alignItems="center"
            key={instruction.key}
            spacing={2}
          >
            <Grid item xs={1}>
              <CheckCircleIcon color="secondary" fontSize="small" />
            </Grid>
            <Grid item xs={11}>
              <Typography variant="body2">{instruction.value}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <Grid item sx={{ my: 1 }}>
        <Button
          sx={{ textTransform: 'none', mt: 2 }}
          type="button"
          fullWidth
          color="secondary"
          variant="contained"
          onClick={() => setStarted()}
          label={t('symptom.START_SYMPTOM_CHECK')}
        />

        <Button
          sx={{ textTransform: 'none', textDecoration: 'underline', mt: 2 }}
          type="button"
          fullWidth
          variant="text"
          onClick={() => navigate(-1)}
          label={t('symptom.START_SYMPTOM_CHECK_NOT_NOW')}
        />
      </Grid>
    </Grid>
  );
}
